export default "__VITE_ASSET__cqiBoTDY__"